import { Button } from "@mui/material"

export function SSOLoginButton({ ssoInfo, checkingSSO, email }) {
    if (checkingSSO || !ssoInfo) return null

    return (
        <Button fullWidth size="large" variant="contained" onClick={handleSSOLogin} data-cy="sso-login-button">
            Sign in with {ssoInfo.providerName || "your organisation"}
        </Button>
    )

    function handleSSOLogin() {
        triggerSSOLogin(ssoInfo, email)
    }
}

export function triggerSSOLogin(ssoInfo, email) {
    const server = window.appServerLocation || process.env.REACT_APP_SERVER
    const protocol = window.appProtocol || process.env.REACT_APP_PROTOCOL || "http"
    const apiBase = server ? `${protocol}://${server}` : ""
    const ssoUrl = `${apiBase}/auth/sso/login?configId=${encodeURIComponent(ssoInfo.configId)}&email=${encodeURIComponent(email)}`
    console.log("[SSO login] triggerSSOLogin called")
    console.log("[SSO login] ssoInfo:", JSON.stringify(ssoInfo))
    console.log("[SSO login] apiBase:", apiBase)
    console.log("[SSO login] Redirecting to:", ssoUrl)
    window.location.href = ssoUrl
}
